import { forwardRef, type Ref, type SVGProps } from "react";
const IconCameraGridFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M11.98 12.01h7.98v7.98h-7.98z" />
    <path d="M2 12.01h7.98v7.98H2z" />
    <path d="M11.98 21.99h7.98V30h-7.98z" />
    <path d="M28 2h-6v8h8V4a2 2 0 0 0-2-2" />
    <path d="M2 28a2 2 0 0 0 2 2h6v-8H2Z" />
    <path d="M22 30h6a2 2 0 0 0 2-2v-6h-8Z" />
    <path d="M2 4v6h8V2H4a2 2 0 0 0-2 2" />
    <path d="M11.98 2h7.98v8.01h-7.98z" />
    <path d="M21.96 12.01H30v7.98h-8.04z" />
  </svg>
);
const ForwardRef = forwardRef(IconCameraGridFilledSVG);
ForwardRef.displayName = "IconCameraGridFilled";
export { ForwardRef as IconCameraGridFilled };
